'use client';

import { useState, useEffect, useCallback } from 'react';

export interface ForumUser {
  _id: string;
  discordId: string;
  username: string;
  avatar: string;
}

// Lean re-implementation of the homepage's Discord login flow so the forum
// doesn't depend on (or risk regressing) src/app/page.tsx.
export function useForumAuth() {
  const [currentUser, setCurrentUser] = useState<ForumUser | null>(null);

  useEffect(() => {
    const saved = localStorage.getItem('bb_user');
    if (saved) {
      try {
        setCurrentUser(JSON.parse(saved));
      } catch {
        /* ignore */
      }
    }
  }, []);

  const login = useCallback(() => {
    const redirectUri =
      process.env.NEXT_PUBLIC_DISCORD_REDIRECT_URI ||
      'https://bladeballranking.vercel.app/api/auth/callback/discord';
    const clientId = process.env.NEXT_PUBLIC_DISCORD_CLIENT_ID || '1510719764488650924';
    const oauthUrl = `https://discord.com/oauth2/authorize?client_id=${clientId}&redirect_uri=${encodeURIComponent(
      redirectUri
    )}&response_type=code&scope=identify`;

    window.open(oauthUrl, 'Discord Login', 'width=500,height=750');

    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== window.location.origin) return;
      if (event.data?.type === 'DISCORD_AUTH_SUCCESS') {
        const user = event.data.user;
        setCurrentUser(user);
        localStorage.setItem('bb_user', JSON.stringify(user));
        window.removeEventListener('message', handleMessage);
      }
    };
    window.addEventListener('message', handleMessage);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('bb_user');
    setCurrentUser(null);
    fetch('/api/auth/logout', { method: 'POST' }).catch(() => {});
  }, []);

  return { currentUser, login, logout };
}
